import { ButtonGroup } from "pepsico-ds";
import PropTypes from "prop-types";
import { useContext } from "react";
import { GlobalConfigContext } from "../../context/GlobalConfigContext";
import { formatDateTz } from "../../utils/commons";
import Table from "../common/table/Table";
import "./customizedRewards.scss";
import { customizedRewardsHeaderData } from "./headerData";
import { useRewardsActions } from "./rewardsActions";

const CustomizedRewardsTable = ({
  customizedRewardsData,
  handleViewReward,
  handleEditReward,
  handleDeleteReward,
}) => {
  const {
    handleViewReward: defaultHandleViewReward,
    handleEditReward: defaultHandleEditReward,
    handleDeleteReward: defaultHandleDeleteReward,
  } = useRewardsActions();

  // Use props if provided, otherwise use defaults from hook
  const onViewReward = handleViewReward || defaultHandleViewReward;
  const onEditReward = handleEditReward || defaultHandleEditReward;
  const onDeleteReward = handleDeleteReward || defaultHandleDeleteReward;
  const { programTimezone } = useContext(GlobalConfigContext);
  const rowData = (customizedRewardsData || []).map((item) => {
    return {
      status: (
        <div className="reward-status-type">
          <span
            className={`reward-status-badge ${item?.isActive === false ? "inactive" : "active"}`}
          >
            {item?.isActive === false ? "Inactive" : "Active"}
          </span>
        </div>
      ),
      campaignsIncluded: item?.uniqueCampaignCount || 0,
      name: item?.name,
      rewards: item?.uniqueRewardCount || 0,
      quantity: item?.newQuantity || "-",
      // activeDate: formatDatesWithHyphen(item?.startDate, item?.endDate),
      startDate: formatDateTz(item?.startDate, programTimezone, "DD/MM/YYYY") || "-",
      endDate: formatDateTz(item?.endDate, programTimezone, "DD/MM/YYYY") || "-",
      action: (
        <ButtonGroup
          items={[
            {
              icon: "visibility",
              onClick: () => onViewReward(item),
              tooltip: "View",
            },
            {
              icon: "edit",
              onClick: () => onEditReward(item),
              tooltip: "Edit",
            },
            // Only show delete button for inactive rewards
            ...(!item?.isActive
              ? [
                  {
                    icon: "delete",
                    onClick: () => onDeleteReward(item),
                    tooltip: "Delete",
                  },
                ]
              : []),
          ]}
        />
      ),
    };
  });

  const tableData = {
    headerData: customizedRewardsHeaderData,
    rowData: rowData,
  };

  return (
    <div className="customized-rewards-table-container">
      {(customizedRewardsData || []).length === 0 ? (
        <div className="no-data-message">No rewards found</div>
      ) : (
        <Table
          headerData={tableData.headerData}
          rowData={tableData.rowData}
          className="customized-rewards-table"
        />
      )}
    </div>
  );
};

CustomizedRewardsTable.propTypes = {
  customizedRewardsData: PropTypes.array.isRequired,
  handleViewReward: PropTypes.func,
  handleEditReward: PropTypes.func,
  handleDeleteReward: PropTypes.func,
};

export default CustomizedRewardsTable;
